<div class="default-dialog-wrapper dialog-wrapper">
	<div class="flex flex-col content">
		<div class="fixed-header">
			<div class="flex flex-row w-100-percent p-24 pl-20">
				<div class="flex flex-col basis-full">
					<div class="fw-700 mat-headline-5 mb-0 fs-12">{{ 'BLUEPRINT_SUMMARY.VIEW_DETAILS' | transloco | uppercase}}</div>
					<div class="mat-headline-5 fw-700 mb-4">{{ blueprintName }}</div>
				</div>
				<mat-icon svgIcon="close" class="cursor-pointer w-32 h-32" (click)="closeDialog()"></mat-icon>
			</div>
			<div class="setup-details p-16 ml-24">
				<ul class="m-0 p-0">
					<li class="mat-subtitle-2 m-0 fw-700">{{'BLUEPRINT_SUMMARY.SETUP_DETAILS' | transloco}}</li>
				</ul>
			</div>
		</div>
		<div class="p-24">
			<div class="flex flex-col">
				<div class="basis-full mat-subtitle-2 fw-700 mb-12 mt--8 fs-20">{{ 'SERVICE.GENERAL' | transloco }}</div>
				<div class="flex flex-row">
					<div class="flex-col w-50-percent">
						<div class="overline-font fs-14 fw-700 mb-4">{{ 'SERVICE.BLUEPRINT_NAME' | transloco | uppercase }}</div>
						<div class="mat-body-1 fw-400 word-break-word mb-4">{{ blueprintName }}</div>
					</div>
					<div class="flex-col pl-100">
						<div class="overline-font fs-14 fw-700 mb-4">{{ 'SOLUTIONS.ISB_TYPES' | transloco | uppercase }}</div>
						<div class="mat-body-1 fw-400 mb-4">{{ ISBMode }}</div>
					</div>
				</div>
			</div>
			<div class="flex flex-col" *ngIf="capabilities?.length > 0">
				<mat-divider class="mb-16 mt-12"></mat-divider>
				<div class="flex-row">
					<div class="basis-full mat-subtitle-2 fw-700 mb-12 fs-20">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES' | transloco}}</div>
				</div>
				<div class="flex flex-row flex-wrap">
					<div class="flex-col w-50-percent mb-0" *ngFor="let capability of includedCapabilities; let i = index" [ngClass]="{'pl-100': (i % 2)}">
           				<div class="mat-body-1 mb-8 overflow-wrap">{{capability?.displayName ? (capability?.displayName) : ((capability?.name) ? (capability?.name) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</div>
					</div>
				</div>
				<!-- <div *ngIf="optionalCapabilities.length > 0">
					<mat-divider class="mb-16 mt-8"></mat-divider>
					<div class="flex-row">
						<div class="basis-full mat-subtitle-2 fw-700 mb-12 fs-20">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.OPTIONAL_CAPABILITIES' | transloco}}</div>
					</div>
					<div class="flex flex-row flex-wrap">
						<div class="flex-col w-50-percent mb-0" *ngFor="let capability of optionalCapabilities let i = index" [ngClass]="{'pl-100': (i % 2)}">
							<div class="mat-body-1 mb-8 overflow-wrap">{{capability?.displayName ? (capability?.displayName | titlecase) : ((capability?.name | titlecase) ? (capability?.name | titlecase) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</div>
						</div>
					</div>
				</div> -->
			</div>
			<div class="flex flex-col" *ngFor="let dynamicFormModel of dynamicFormModels">
				<mat-divider class="mb-16 mt-12"></mat-divider>
				<div class="flex-row">
					<div class="basis-full mat-subtitle-2 fw-700 mb-12 fs-20">{{ dynamicFormModel?.property?.title }}</div>
				</div>
				<div class="flex flex-row flex-wrap">
					<div *ngIf="dynamicFormModel?.property?.type === InstallationSchemaPropertyType.ARRAY">
						<div *ngFor="let arrayItems of dynamicFormModel?.property?.items?.enum; let last = last;" class="mat-body-1 mb-8 overflow-wrap" [ngClass]="{'mb-16': last}">
							{{arrayItems}}
						</div>
					</div>
					<div class="flex-col w-50-percent mb-0" *ngFor="let property of dynamicFormModel?.property?.properties let i = index" [ngClass]="{'pl-100': (i % 2)}">
						<label class="overline-font letter-spacing fs-14 mb-6 mt-8">{{ property?.title | uppercase }}</label>
						<ng-container *ngIf="property?.type === InstallationSchemaPropertyType.ARRAY; else notArrayFormat">
							<ng-container *ngIf="property?.value?.length > 0; else hyphen">
								<div *ngFor="let arrayItems of property?.value; let last = last;" class="mat-body-1 mb-8 overflow-wrap" [ngClass]="{'mb-16': last}">
									{{arrayItems}}
								</div>
							</ng-container>
							<ng-template #hyphen>
								<div class="mb-8">-</div>
							</ng-template>
						</ng-container>
						<ng-template #notArrayFormat>
							<div class="mat-body-1 mb-8 overflow-wrap">{{property?.type===InstallationSchemaPropertyType.DATE? (property?.value | date:('dd MMM yyyy hh:mm')+ ' UTC') : typeOfPropertyValue(property?.value)? '-' : property?.value}}</div>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
